import { render, staticRenderFns } from "./modal-edit-page.vue?vue&type=template&id=220a7cbb&scoped=true"
import script from "./modal-edit-page.vue?vue&type=script&lang=js"
export * from "./modal-edit-page.vue?vue&type=script&lang=js"
import style0 from "./modal-edit-page.vue?vue&type=style&index=0&id=220a7cbb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220a7cbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('220a7cbb')) {
      api.createRecord('220a7cbb', component.options)
    } else {
      api.reload('220a7cbb', component.options)
    }
    module.hot.accept("./modal-edit-page.vue?vue&type=template&id=220a7cbb&scoped=true", function () {
      api.rerender('220a7cbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-page/components/modal-edit-page.vue"
export default component.exports